import { render, staticRenderFns } from "./ScoreTrendChart.vue?vue&type=template&id=42c807e6&scoped=true"
import script from "./ScoreTrendChart.vue?vue&type=script&lang=js"
export * from "./ScoreTrendChart.vue?vue&type=script&lang=js"
import style0 from "./ScoreTrendChart.vue?vue&type=style&index=0&id=42c807e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c807e6",
  null
  
)

export default component.exports